import React, { HTMLAttributes } from 'react';
import { keyframes } from '@emotion/css';
import styled from '@emotion/styled';
import IcoMoonIcon from 'tradevan-ui/IcoMoonIcon';
import { IcoMoonIconsEnum } from 'tradevan-ui/IcoMoonIcon/svg';

const circleAnimation = keyframes`
from {
  transform: scale(0) rotate(-90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(0deg);
	opacity: 1;
}`;
const StyledDiv = styled('div')<WarningTheme>`
  width: 20px;
  opacity: 0;
  height: 20px;
  color: ${(p) => p.primary || '#f7b84b'};

  animation: ${circleAnimation} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
`;

export interface WarningTheme {
  primary?: string;
  // secondary?: string;
}

export interface WarningIconProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'children'>,
    WarningTheme {}

/** 警告 icon
 * - 參考 node_modules\react-hot-toast\src\components\checkmark.tsx 製作 */
export const WarningIcon = (props: WarningIconProps) => (
  <StyledDiv {...props}>
    <IcoMoonIcon icon={IcoMoonIconsEnum.Warning} strokeWidth="24" />
  </StyledDiv>
);
